import { useState, useEffect, useCallback } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

const useLocalNotificationJSONManager = () => {
    const [notificationGroups, setNotificationGroups] = useState([]);

    // Load notification groups from AsyncStorage
    const loadNotificationGroups = useCallback(async () => {
        try {
            const storedGroupsJson = await AsyncStorage.getItem('localNotificationGroups');
            const storedGroups = storedGroupsJson ? JSON.parse(storedGroupsJson) : [];
            setNotificationGroups(storedGroups);
        } catch (error) {
            console.error("Failed to load notification groups:", error);
        }
    }, []);

    // Create a new notification group and save to AsyncStorage
    const createNotificationGroup = async (newGroup) => {
        try {
            const storedGroupsJson = await AsyncStorage.getItem('localNotificationGroups');
            const storedGroups = storedGroupsJson ? JSON.parse(storedGroupsJson) : [];
            const updatedGroups = [...storedGroups, newGroup];
            await AsyncStorage.setItem('localNotificationGroups', JSON.stringify(updatedGroups));
            loadNotificationGroups();
            return true;
        } catch (error) {
            console.error("Failed to create notification group:", error);
            return false;
        }
    };

    // Update an existing notification group and save to AsyncStorage
    const updateNotificationGroup = async (identifier, updatedGroupDetails) => {
        try {
            const storedGroupsJson = await AsyncStorage.getItem('localNotificationGroups');
            const storedGroups = storedGroupsJson ? JSON.parse(storedGroupsJson) : [];
            const updatedGroups = storedGroups.map(group =>
                group.id === identifier ? { ...group, ...updatedGroupDetails } : group
            );
            await AsyncStorage.setItem('localNotificationGroups', JSON.stringify(updatedGroups));
            loadNotificationGroups();
        } catch (error) {
            console.error("Failed to update notification group:", error);
        }
    };

    // Delete a notification group and save to AsyncStorage
    const deleteNotificationGroup = async (identifier) => {
        try {
            const storedGroupsJson = await AsyncStorage.getItem('localNotificationGroups');

            if (!storedGroupsJson) {
                return;
            }

            const storedGroups = JSON.parse(storedGroupsJson);
            const updatedGroups = storedGroups.filter(group => group.id !== identifier);
            await AsyncStorage.setItem('localNotificationGroups', JSON.stringify(updatedGroups));
            loadNotificationGroups();
        } catch (error) {
            console.error("Failed to delete notification group:", error);
        }
    };


    // Creates notification group from list of system notification objects.
    const createNotificationGroupFromDetails = async (notificationDetails) => {
        try {

            console.log('notificationDetails' , notificationDetails);

            const days = notificationDetails.map(detail => detail.trigger.weekday);
            const identifiers = notificationDetails.map(detail => detail.identifier);

            const firstNotification = notificationDetails[0];
            const trigger = firstNotification.trigger;
            const hour = firstNotification.trigger.hour.toString().padStart(2, '0');
            const minute = firstNotification.trigger.minute.toString().padStart(2, '0');
            const time = `${hour}:${minute}`;

            const id = `group-${Date.now()}`; // Generate a unique ID for the group
            const messageModified = Date.now();

            const notificationGroup = {
                id,
                time,
                originalTimestamp: firstNotification.originalTimestamp,
                days,
                trigger,
                identifiers,
                messageModified
            };

            // Use the already defined method to create a new group and handle AsyncStorage update
            await createNotificationGroup(notificationGroup).then((e) => {
               return true;
            });

        } catch (error) {
            console.error("Failed to create notification group from details:", error);
        }
    };


    // Load notification groups on hook initialization
    useEffect(() => {
        loadNotificationGroups();
        console.log('loadNotificationGroups');
    }, [loadNotificationGroups]);

    useEffect(() => {
        loadNotificationGroups();
        console.log('loadNotificationGroups');
    }, []);

    return {
        notificationGroups,
        createNotificationGroup,
        updateNotificationGroup,
        deleteNotificationGroup,
        createNotificationGroupFromDetails
    };
};

export default useLocalNotificationJSONManager;
